import React from 'react';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';

const QuotesNoTabsView = () => {
  const {
    quotes,
    isMobile
  } = useQuoteContext();

  return (
    <>
      {isMobile ? (
        <QuotesCompactList quotes={quotes} />
      ) : (
        <QuotesCarousel quotes={quotes} />
      )}
    </>
  );
};

QuotesNoTabsView.propTypes = {
};
QuotesNoTabsView.defaultProps = {
};

export default QuotesNoTabsView;
